module.exports = __webpack_public_path__ + "static/media/loader.0a750511.svg";